<template>
    <div class="mobile_wrap">
        <div class="bg_wrap">
            <div class="fr_wrap" id="fr_wrap" v-if="first_wrap">
                <div class="bg_tlt"></div>
                <div class="sub_tlt"></div>
                <div class="sel_wrap">
                    <button class="kr" id="kr_btn" @click="counter('korea')">한식</button>
                    <button class="ch" id="ch_btn" @click="counter('china')">중식</button>
                    <button class="en" id="ya_btn" @click="counter('yang')">양식</button>
                    <button class="jp" id="jp_btn" @click="counter('japan')">일식</button>
                    <button class="de" id="bd_btn" @click="counter('bundi')">분식</button>
                </div>
                <button class="start" id="set_spin" @click="setSpin()"><img id="start" src="@/assets/img/event/spin_btn.png"/></button>
            </div>
            <div class="se_wrap" id="se_wrap" v-if="second_wrap">
                <div class="tlt_wrap">
                    <img class="logo" src="@/assets/img/event/logo.png" />
                    <img class="tlt" src="@/assets/img/event/tlt.png"/>
                </div>
                <div class="step_wrap" id="step_wrap">
                    <div class="gif_wrap" id="gif_wrap" v-if="gif_wrap">
                        <p class="step"><img  :src="require(`@/assets/img/event/${once}.gif`)"  id="once" /></p>
                    </div>
                    <div class="target_wrap" id="target_wrap" v-if="target_wrap">
                        <img :src="require(`@/assets/img/event/menu/${result_txt}.png`)" class="step_img" />
                        <img :src="require(`@/assets/img/event/menu/${result_txt}.png`)" class="step_img" />
                        <img :src="require(`@/assets/img/event/menu/${result_txt}.png`)" class="step_img" />
                    </div> 
                </div> 
                <img class="sub_tlt2" src="@/assets/img/event/sub_2.png" />
                <div class="result_wrap">
                    <p id="result_txt" class="txt">???</p>
                </div>
                <button class="restart"  id="re_spin" v-if="restart" @click="reSpin()">다시돌리기</button>
                <button class="restart more" id="moreRecipe" v-if="restart" @click="moreRe()">레시피 보러가기</button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@font-face {
    font-family: 'BlackHanSans-Regular';
    font-style: normal;
    font-weight: 600;
    src: url('../../src/assets/font/BlackHanSans-Regular.woff'),
	url('../../src/assets/font/BlackHanSans-Regular.woff2');
}
.mobile_wrap {
    position:relative;
    overflow:hidden;
}
.bg_wrap {
    position:relative;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    background:url("../../src/assets/img/event/bg.jpg") 0 0 no-repeat;
    background-size:cover;
    //overflow:hidden;
    .fr_wrap {
        overflow:hidden;
        .bg_tlt{
            position:absolute;
            top:12%;
            left:50%;
            transform:translateX(-50%);
            width:79.3056vw;
            height:56.6667vw;
            background:url("../../src/assets/img/event/maintlt.png") 0 0 no-repeat;
            background-size:79.3056vw 56.6667vw;
        }
        .sub_tlt{
            position:absolute;
            top:45%;
            left:50%;
            transform:translateX(-50%);
            width:74.3056vw;
            height:7.7778vw;
            background:url("../../src/assets/img/event/sub_1.png") 0 0 no-repeat;
            background-size:74.3056vw 7.7778vw;
        }
        .sel_wrap{
            position:absolute;
            top: 54%;
            left:50%;
            transform:translateX(-50%);
            width:100.0000vw;
            height:25.8333vw;
            .kr, .ch, .en, .jp, .de{
                position:absolute;
                width: 41.1111vw;
                height: 46.6667vw;
                text-indent:-2777.5000vw;
                border:0;
            }
            .kr{
                left:0;
                background:url("../../src/assets/img/event/kr_btn_inact.png") 0 0 no-repeat;
                background-size: 65%; 
            }
            .kr.active{
                left:0;
                background:url("../../src/assets/img/event/kr_btn_act.png") 0 0 no-repeat;
                background-size: 65%;
            }
            .ch{
                left: 18.5556vw;
                background:url("../../src/assets/img/event/ch_btn_inact.png") 0 0 no-repeat;
                background-size: 65%;
            }
            .ch.active{
                left: 18.5556vw;
                background:url("../../src/assets/img/event/ch_btn_act.png") 0 0 no-repeat;
                background-size: 65%;
            }
            .en{
                left: 38.1111vw;
                background:url("../../src/assets/img/event/en_btn_inact.png") 0 0 no-repeat;
                background-size: 65%;
            }
            .en.active{
                left: 38.1111vw;
                background:url("../../src/assets/img/event/en_btn_act.png") 0 0 no-repeat;
                background-size: 65%;
            }
            .jp{
                left: 56.75vw;
                background:url("../../src/assets/img/event/jp_btn_inact.png") 0 0 no-repeat;
                background-size: 65%;
            }
            .jp.active{
                left: 56.75vw;
                background:url("../../src/assets/img/event/jp_btn_act.png") 0 0 no-repeat;
                background-size: 65%; 
            }
            .de{
                left: 76.2222vw;
                background:url("../../src/assets/img/event/de_btn_inact.png") 0 0 no-repeat;
                background-size: 65%;
            }
            .de.active{
                left: 76.2222vw;
                background:url("../../src/assets/img/event/de_btn_act.png") 0 0 no-repeat;
                background-size: 65%;
            }
        }
        .start{
            position: absolute;
            top: 75%;
            left: 24%;
            width: 57%;
            height: 8%;
            text-indent: -2777.5vw;
            border:0;
            background-color:transparent;
            #start{
                display:block;
                width:58.4722vw;
                height:12.5000vw;
            }
        }
    }
    .se_wrap {
        position:relative;
        top:7.5%;
        .tlt_wrap{
            position:relative;
            width:100vw;
            height:45vw;
            .logo {
            position: absolute;
            top: 12.5%;
            left: 50%;
            width: 30vw;
            transform: translate(-50%, 0);
            }
            .tlt{
                position: absolute;
                top: 43.5%;
                left: 50%;
                width: 80%;
                transform: translate(-50%, 0);
            }
        }
        .step_wrap{
            position:absolute;
            width: 81.9967vw;
            height: 47.1614vw;
            overflow:hidden;
            top: 164%;
            left: 50%;
            right:0;
            bottom:0;
            transform: translate(-48%,-50%);
            background: url('../../src/assets/img/event/slot.png') 0 0 no-repeat;
            background-size: 100% 100%;
            .gif_wrap {
                position:absolute;
                top: 22%;
                left: 6.5%;
                border-radius: 1.6667vw;
                z-index: 999;
                .step{
                    position:absolute;
                    width: 62.7499vw;
                    height: 19.5833vw;
                }
                #once{
                    //display:none;
                    width:100%;
                }
            }
            .target_wrap {
                position:absolute;
                top: 22%;
                left: 6.5%;
                width:62.7499vw;
                height:19.5833vw;
                .step_img {
                    width:19.5833vw;
                    height:100%;
                    border-radius:1.6667vw;
                }
                .step_img+.step_img{
                    margin-left: 2vw;
                }
            }

        }
        .sub_tlt2{
            position: absolute;
            top:242%;
            left:50%;
            width:70%;
            transform: translate(-50%, 0);
        }
        .result_wrap {
            position:absolute;
            border-radius: 11.1111vw;
            left: 50%;
            top: 287%;
            width:100vw;
            height: 11.1111vw;
            transform: translate(-50%,0);
            .txt{
                text-align: center;
                line-height: 11.1111vw;
                color: #e56646;
                font-family: 'BlackHanSans-Regular', sans-serif;
                font-size: 2rem;
                margin: 0;
                margin-block-start: 0;
                margin-block-end: 0;
            }
        }
        .restart {
            position:absolute;
            top: 320%;
            left:50%;
            transform:translateX(-50%);
            width:36.9444vw;
            height: 11.3889vw;
            text-indent:-2777.5000vw;
            border:0;
            background:url("../../src/assets/img/event/reroll_new.png") 0 0 no-repeat;
            background-size: contain;
        }
        .more {
            position:absolute;
            top:350%;
            left:50%;
            transform:translateX(-50%);
            width:36.9444vw;
            height: 11.3889vw;
            text-indent:-2777.5000vw;
            border:0;
            background:url("../../src/assets/img/event/btn_moreapp.png") 0 0 no-repeat;
            background-size: contain;
        }
    }
}
</style>

<script>
import Loading from "../components/Loading";
import { useRoute } from 'vue-router'

export default {
  name: "RecMenu",
  components: {
    Loading,
  },
  data: function () {
    const route = useRoute()
    //const { query } = route;
    return {
        loading: true,
        first_wrap : true,
        second_wrap : false,
        target_wrap : false,
        restart : false,
        gif_wrap : false,
        kr_act: 0,
        ch_act: 0,
        jp_act: 0,
        ya_act: 0,
        bd_act: 0,
        result_txt : "",
        style_list : [],
        once : 'once',
        korea:[
            {
                idx : 0,
                name : "김밥",
                weight : 5,
            }, {
                idx : 1,
                name : "낙지덥밥",
                weight: 5,
            }, {
                idx: 2,
                name : "계란볶음밥",
                weight: 1,
            }, {
                idx: 3,
                name : "새우볶음밥",
                weight:1,
            }, {
                idx : 4,
                name : "김치볶음밥",
                weight: 5,
            }, {
                idx : 5,
                name : "야채볶음밥",
                weight: 1
            }, {
                idx : 6,
                name : "콩나물비빔밥",
                weight: 1
            }, {
                idx : 7,
                name : "돌솥비빔밥",
                weight: 7,
            }, {
                idx : 8,
                name : "육회비빔밥",
                weight: 7,
            }, {
                idx :9, 
                name : "오므라이스",
                weight: 1
            }, {
                idx: 10,
                name: "짜장밥",
                weight : 1
            }, {
                idx : 11,
                name: "카레라이스",
                weight: 1
            }, {
                idx : 12,
                name : "하이라이스",
                weight : 1,
            }, {
                idx : 13,
                name : "회덮밥",
                weight: 5,
            }, {
                idx : 14,
                name : "제육덮밥",
                weight: 7,
            }, {
                idx : 15,
                name : "열무비빔밥",
                weight : 7,
            }, {
                idx:16,
                name: "쌈밥",
                weight: 7,
            }, {
                idx:17,
                name: "충무김밥",
                weight: 1,
            }, {
                idx:18,
                name : "불고기덮밥",
                weight: 1,
            }, {
                idx:19,
                name : "주먹밥",
                weight: 1,
            }, {
                idx:20,
                name : "수제비",
                weight: 5,
            }, {
                idx:21,
                name : "참치죽",
                weight: 1,
            }, {
                idx:22,
                name : "야채죽",
                weight: 1,
            }, {
                idx : 23,
                name : "꼬막비빔밥",
                weight:5
            }, {
                idx : 24,
                name:"닭볶음탕",
                weight:5,                
            }, {
                idx:25,
                name:"간장계란밥",
                weight:1,
            }, {
                idx : 26,
                name : "갈비찜",
                weight:1
            }, {
                idx : 27,
                name : "갈비탕",
                weight:1,
            }, {
                idx : 28,
                name : "고등어구이",
                weight: 5,
            }, {
                idx:29,
                name : "두부김치",
                weight:1,
            }, {
                idx:30,
                name:"비빔밥",
                weight:5,
            }, {
                idx:31,
                name:"소불고기",
                weight:1,
            }, {
                idx:32,
                name:"수육",
                weight:1
            }, {
                idx:33,
                name : "순대볶음",
                weight:1,
            }, {
                idx:34,
                name: "막국수",
                weight:1,
            }, {
                idx:35,
                name:"비빔국수", 
                weight:1,
            }, {
                idx:36,
                name :"잔치국수",
                weight: 7,
            },{
                idx:37,
                name :"쟁반국수",
                weight: 1,
            },{
                idx:38,
                name :"물냉면",
                weight:7,
            },{
                idx:39,
                name :"비빔냉면",
                weight: 1,
            },{
                idx:40,
                name :"회냉면",
                weight:1,
            },{
                idx:41,
                name :"바지락칼국수",
                weight: 7,
            },{
                idx:42,
                name :"열무냉면",
                weight: 1,
            },{
                idx:43,
                name :"김치말이국수",
                weight: 7,
            },{
                idx:44,
                name :"들깨칼국수",
                weight: 1,
            },{
                idx:45,
                name :"닭칼국수",
                weight: 1,
            },{
                idx:46,
                name :"육개장칼국수",
                weight: 1,
            },{
                idx:47,
                name :"순대국밥",
                weight: 7,
            },{
                idx:48,
                name :"굴국밥",
                weight: 1,
            },{
                idx:49,
                name :"돼지국밥",
                weight: 1,
            },{
                idx:50,
                name :"설렁탕",
                weight: 1,
            },{
                idx:51,
                name :"감자탕",
                weight:7,
            },{
                idx:52,
                name :"돼지고기김치찌개",
                weight: 7,
            },{
                idx:53,
                name :"참치김치찌개",
                weight: 1,
            },{
                idx:54,
                name :"동태찌개",
                weight: 7,
            },{
                idx:55,
                name :"된장찌개",
                weight: 1,
            },{
                idx:56,
                name :"매운탕",
                weight: 1,
            },{
                idx:57,
                name :"버섯전골",
                weight: 1,
            },{
                idx:58,
                name :"부대찌개",
                weight: 1,
            },{
                idx:59,
                name :"샤브샤브",
                weight: 1,
            },{
                idx:60,
                name :"순두부찌개",
                weight: 7,
            },{
                idx:61,
                name :"청국장",
                weight: 7,
            },{
                idx:62,
                name :"추어탕",
                weight: 7,
            },{
                idx:63,
                name :"콩비지찌개",
                weight: 1,
            },{
                idx:64,
                name :"곱창전골",
                weight: 1,
            },{
                idx:65,
                name :"꽃게탕",
                weight: 1,
            },{
                idx:66,
                name :"돼지고기짜글이",
                weight: 1,
            },{
                idx:67,
                name :"만두전골",
                weight: 7,
            },{
                idx:68,
                name :"밀푀유나베",
                weight: 1,
            },{
                idx:69,
                name :"해물탕",
                weight: 1,
            },{
                idx:70,
                name :"알탕",
                weight: 1,
            },{
                idx:71,
                name :"고추장찌개",
                weight: 1,
            },{
                idx:72,
                name :"황태해장국",
                weight: 1,
            },{
                idx:73,
                name :"콩나물해장국",
                weight: 7,
            },{
                idx:74,
                name :"선지해장국",
                weight: 1,
            },{
                idx:75,
                name :"뼈다귀해장국",
                weight: 1,
            },{
                idx:76,
                name :"복지리탕",
                weight: 7,
            },{
                idx:77,
                name :"대구지리탕",
                weight: 1,
            },{
                idx:78,
                name :"꼬리곰탕",
                weight: 1,
            },{
                idx:79,
                name :"고등어찌개",
                weight: 1,
            },{
                idx:80,
                name :"꽁치찌개",
                weight: 1,
            },{
                idx:81,
                name :"육개장",
                weight: 7,
            },{
                idx:82,
                name :"곰탕",
                weight: 1,
            },{
                idx:83,
                name :"아귀찜",
                weight: 1,
            }
        ],
        china:[
            {
                idx:0,
                name:"짜장면",
                weight:7,
            },
            {
                idx:1,
                name:"짜장밥",
                weight:1,
            },
            {
                idx:2,
                name:"짬뽕",
                weight:7,
            },
            {
                idx:3,
                name:"짬뽕밥",
                weight:1,
            },
            {
                idx:4,
                name:"잡채밥",
                weight:1,
            },{
                idx:5,
                name:"간짜장",
                weight:1,
           },{
                idx:6,
                name:"기스면",
                weight:1,
            },{
                idx:7,
                name:"삼선우동",
                weight:1,
            },{
                idx:8,
                name:"삼선짜장",
                weight:1,
            },{
                idx:9,
                name:"홍합짬뽕",
                weight:1,
            },{
                idx:10,
                name:"삼선짬뽕",
                weight:1,
            },{
                idx:11,
                name:"백짬뽕",
                weight:1,
            },
            {   
                idx:12,
                name:"차돌박이짬뽕",
                weight:1,
            },{
                idx:13,
                name:"유산슬덮밥",
                weight:1,
            },{
                idx:14,
                name:"훠궈",
                weight:1,
            },{
                idx:15,
                name:"마라탕",
                weight:1,
            },{
                idx:16,
                name:"울면",
                weight:1,
            },{
                idx:17,
                name:"볶음밥",
                weight:1,
            },{
                idx:18,
                name:"마파두부밥",
                weight:1,
            },{
                idx:19,
                name:"사천탕면",
                weight:1,
            },{
                idx:20,
                name:"해물덮밥",
                weight:1,
            },{
                idx:21,
                name:"잡탕밥",
                weight:7,
            },{
                idx:22,
                name:"중국집우동",
                weight:1,
            }
        ],
        japan:[
            {
                idx:0,
                name:"돈코츠라멘",
                weight:1,
            },{
                idx:1,
                name:"미소라멘",
                weight:1,
            },{
                idx:2,
                name:"소유라멘",
                weight:1,
            },{
                idx:3,
                name:"시오라멘",
                weight:1,
            },{
                idx:4,
                name:"광어초밥",
                weight:7,
            },{
                idx:5,
                name:"연어초밥",
                weight:1,
            },{
                idx:6,
                name:"새우초밥",
                weight:7,
            },{
                idx:7,
                name:"유부초밥",
                weight:1,
            },{
                idx:8,
                name:"캘리포니아롤",
                weight:1,
            },{
                idx:9,
                name:"히레카츠",
                weight:1,
            },{
                idx:10,
                name:"로스카츠",
                weight:1,
            },{
                idx:11,
                name:"일식우동",
                weight:7,
            },{
                idx:12,
                name:"탄탄면",
                weight:7,
            },{
                idx:13,
                name:"차슈덮밥",
                weight:1,
            },{
                idx:14,
                name:"가라아게동",
                weight:1,
            },{
                idx:15,
                name:"마제멘",
                weight:1,
            },{
                idx:16,
                name:"나가사키라멘",
                weight:1,
            },{
                idx:17,
                name:"규동",
                weight:1,
            },{
                idx:18,
                name:"가츠동",
                weight:1,
            },{
                idx:19,
                name:"일본식카레",
                weight:7,
            },{
                idx:20,
                name:"메밀소바",
                weight:7,
            },{
                idx:21,
                name:"야끼우동",
                weight:1,
            },{
                idx:22,
                name:"오야꼬동",
                weight:1,
            },{
                idx:23,
                name:"비빔소바",
                weight:1,
            }
        ],
        yang:[
            {
                idx:0,
                name:"분짜",
                weight:1,
            },{
                idx:1,
                name:"쌀국수",
                weight:7,
            },{
                idx:2,
                name:"팟타이",
                weight:1,
            },{
                idx:3,
                name:"반미",
                weight:1,
            },{
                idx:4,
                name:"푸팟퐁커리",
                weight:1,
            },{
                idx:5,
                name:"똠양꿍",
                weight:1,
            },{
                idx:6,
                name:"까르보나라스파게티",
                weight:1,
            },{
                idx:7,
                name:"로제스파게티",
                weight:1,
            },{
                idx:8,
                name:"오일스파게티",
                weight:1,
            },{
                idx:9,
                name:"토마토스파게티",
                weight:1,
            },{
                idx:10,
                name:"크림리조또",
                weight:1,
            },{
                idx:11,
                name:"토마토리조또",
                weight:1,
            },{
                idx:12,
                name:"김치필라프",
                weight:1,
            },{
                idx:13,
                name:"새우필라프",
                weight:1,
            },{
                idx:14,
                name:"햄버거",
                weight:7,
            },{
                idx:15,
                name:"수제버거",
                weight:1,
            },{
                idx:16,
                name:"피자",
                weight:7,
            },{
                idx:17,
                name:"치킨",
                weight:7,
            },{
                idx:18,
                name:"케밥",
                weight:1,
            },{
                idx:19,
                name:"차오미엔",
                weight:1,
            },{
                idx:20,
                name:"인도카레",
                weight:1,
            },{
                idx:21,
                name:"나시고랭",
                weight:1,
            },{
                idx:22,
                name:"미고랭",
                weight:1,
            },{
                idx:23,
                name:"스테이크",
                weight:7,
            },
        ],
        bundi:[
            {
                idx:0,
                name:"떡국",
                weight:7,
            },{
                idx:1,
                name:"만두국",
                weight:7,
            },{
                idx:2,
                name:"떡볶이",
                weight:1,
            },{
                idx:3,
                name:"라볶이",
                weight:1,
            },{
                idx:4,
                name:"고구마돈까스",
                weight:1,
            },{
                idx:5,
                name:"치즈돈까스",
                weight:1,
            },{
                idx:6,
                path:"돈까스",
                weight:7,
            },{
                idx:7,
                name:"라면",
                weight:7,
            },{
                idx:8,
                name:"쫄면",
                weight:1,
            },{
                idx:9,
                name:"짜장떡볶이",
                weight:1,
            },{
                idx:10,
                name:"닭강정",
                weight:1,
            },{
                idx:11,
                name:"핫도그",
                weight:1,
            },{
                idx:12,
                name:"샐러드",
                weight:1,
            },{
                idx:13,
                name:"샌드위치",
                weight:1,
            },{
                idx:14,
                name:"팬케이크",
                weight:1,
            },{
                idx:15,
                name:"소시지빵",
                weight:1,
            },{
                idx:16,
                name:"베이글",
                weight:1,
            },{
                idx:17,
                name:"햄치즈머핀",
                weight:1,
            },{
                idx:18,
                name:"미국식핫도그",
                weight:1,
            },{
                idx:19,
                name:"크로플",
                weight:1,
            },{
                idx:20,
                name:"시리얼",
                weight:1,
            },
        ]
    };
  },
  methods: {
    async update() {
      this.loading = true;
      const route = useRoute()
      const { query } = route;
    },
    counter(type){
    let button = document.getElementById('kr_btn');
    switch (type){
        case "korea":
        this.kr_act++;
        this.kr_act = this.kr_act % 2;
        button =document.getElementById('kr_btn');
        if(this.kr_act==0){
            button.className="kr"
        } else {
            button.className="kr active"
        }
        break;
        case "china":
        this.ch_act++;
        this.ch_act = this.ch_act %2;
        button = document.getElementById('ch_btn');
        if(this.ch_act==0){
            button.className="ch"
        } else {
            button.className="ch active"
        }
        break;
        case "japan":
        this.jp_act++;
        this.jp_act = this.jp_act %2;
        button =document.getElementById('jp_btn');
        if(this.jp_act==0){
            button.className="jp"
        } else {
            button.className="jp active"
        }
        break;
        case "yang":
        this.ya_act++;
        this.ya_act = this.ya_act %2;
        button =document.getElementById('ya_btn');
        if(this.ya_act==0){
            button.className="en"
        } else {
            button.className="en active"
        }
        break;
        case "bundi":
        this.bd_act++;
        this.bd_act = this.bd_act %2;
        button =document.getElementById('bd_btn');
        if(this.bd_act==0){
            button.className="de"
        } else {
            button.className="de active"
        }
        break;
        }
    },
    setSpin(){
        function setTargetList(target_style){
            let slot_list = [];
            [target_style].forEach(e => {
            for(let i=0;i<e.weight;i++){
                slot_list.push(e);
            }
            });
            return slot_list;
        }

        if(this.kr_act == 1) this.style_list.push(...this.korea);
        if(this.ch_act == 1) this.style_list.push(...this.china);
        if(this.jp_act == 1) this.style_list.push(...this.japan);
        if(this.ya_act == 1) this.style_list.push(...this.yang);
        if(this.bd_act == 1) this.style_list.push(...this.bundi);

        if(this.kr_act+this.ch_act+this.jp_act+this.ya_act+this.bd_act >0){
            let style_random = Math.floor(Math.random()*this.style_list.length);
            let target_style = this.style_list[style_random];
            let slot_list = setTargetList(target_style);
            let target = Math.floor(Math.random()*slot_list.length);

            this.result_txt = slot_list[target].name;
            this.second_wrap = true;
            this.first_wrap = false;
           

        } else {
            window.alert("선택해주세요");
            return;
        }
        this.gif_wrap = true;
        
        if(this.once === 'once') {
            this.once = 'twice';
        }else if(this.once === 'twice'){
            this.once = 'once';
        }

        setTimeout(()=>{
        this.gif_wrap = false;
        this.target_wrap = true;
        this.restart = true;
        document.getElementById('result_txt').innerText = this.result_txt;
      
        },1500);
    },
    reSpin(){
        this.gif_wrap = true;
        if(this.once === 'once') {
                this.once = 'twice';
        }else {
            this.once = 'once';
        }
        this.restart = false;
        this.target_wrap = false;
        
        function setTargetList(target_style){
            let slot_list = [];
            [target_style].forEach(e => {
            for(let i=0;i<e.weight;i++){
                slot_list.push(e);
            }
            });
            return slot_list;
        }
        let style_random = Math.floor(Math.random()*this.style_list.length);
        let target_style = this.style_list[style_random];
        let slot_list = setTargetList(target_style);
        let target = Math.floor(Math.random()*slot_list.length);

        document.getElementById('result_txt').innerText = "???";
        setTimeout(()=>{
        this.gif_wrap = false;
        this.target_wrap = true;
        this.restart = true;

        this.result_txt = slot_list[target].name;
        document.getElementById('result_txt').innerText = this.result_txt;
        },1500);
    },
    moreRe(){ //레시피보러가기
        window.location.href=`/screen/search?keyword=`+encodeURIComponent(this.result_txt);
    }
}
}
</script>